import { color } from '../../../resources/color';

export const getClaimStatusTextColor = (status) => {
  switch (status) {
    case 'WAIT':
      return color.blueFocus;
    case 'WAIT_PAYMENT':
      return color.yellowRizz;
    case 'PREPARING':
      return color.yellowRizz;
    case 'TRANSPORTED':
      return color.greenRizz;
    case 'REJECTED':
      return color.red;
    default:
      return color.gray;
  }
};

export const getClaimStatusBgColor = (status) => {
  switch (status) {
    case 'WAIT':
      return color.bg_blue;
    case 'WAIT_PAYMENT':
      return color.light_yellow;
    case 'PREPARING':
      return color.light_yellow;
    case 'TRANSPORTED':
      return color.light_green;
    case 'REJECTED':
      return color.bg_red;
    default:
      return color.bg_gray;
  }
};

export const getExpCoupon = (type) => {
  return type === 'BIRTHDAY' ? 'เฉพาะในเดือนเกิด' : 'ตลอดอายุการเป็นสมาชิก 1 ปี';
};
